<template>
    <div class="detail-box">
        <div class="course-info-box">
            <img class="course-cover" :src="courseDetail.goodsCover" alt="">
            <div class="course-title">
                {{ courseDetail.goodsTitle }}
            </div>
            <div class="text"><img src="../../../assets/icon/course_icon1.png" alt="">
                <span>{{ courseDetail.className }}</span>
            </div>
            <div class="text"><img src="../../../assets/icon/course_icon2.png" alt="">
                <span>{{ courseDetail.teacherName }}</span>
            </div>
            <div class="text"><img src="../../../assets/icon/course_icon3.png" alt="">
                <span>{{ parseTime(courseDetail.createTime, '{y}-{m}-{d} {h}:{i}') }}</span>
            </div>
            <div class="btn">
                <div class="name">
                    <img src="../../../assets/icon/book_icon.png" alt="">
                    <div>{{ bookTitle }}</div>

                </div>
                <div class="read" @click="ToRead()">立即阅读 ></div>
            </div>
        </div>
        <div class="resources-box">
            <div>
                <div class="Details_title">
                    <div style="cursor: pointer; margin-right: 5px;"><i @click="arrowLeft" style="font-size: 20px;"
                            class="el-icon-arrow-left"></i></div> 讨论详情
                </div>
                <div class="discussion_x"></div>
                <div class="discussion_box">
                    <div class="discussion_title">
                        {{ Info.title }}
                    </div>
                    <div class="discussion_name" v-html="Info.content"></div>
                    <div class="discussion_row">
                        <div class="discussion_row discussion_num">
                            <!-- <img style="width: 18px; height: 18px;" src="../../../static/image/image_bg/msg.png">
                            </img> -->
                            <div style="margin-left: 10px;">{{ total }}条回复</div>
                        </div>
                        <div class="discussion_time">{{ Info.createTime }}</div>
                    </div>
                    <div class="reply_box" v-for="(item, index) in ReplyList" :key="index">
                        <div class="discussion_row">
                            <img v-if="item.userCover" class="reply_img" :src="item.userCover"></img>
                            <img v-else class="reply_img" src="@/assets/images/default-avatar.png">
                            </img>
                            <div style="margin-left: 15px;">
                                <div class="name">{{ item.createBy }}</div>
                                <div class="time">{{ item.createTime }}</div>
                            </div>
                        </div>
                        <div class="reply_title">{{ item.content }}</div>
                        <div class="teaching_reply" v-if="item.children">
                            <div v-for="(items, index) in item.children" :key="index">
                                教师回复：{{ items.content }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="Info.status == 1">
                    <div class="bottom_box">
                        <el-input type="textarea" :rows="5" placeholder="请输入内容" maxlength="300" v-model.trim="content">
                        </el-input>
                    </div>
                    <div class="bottom_but" style="margin-left: 10px;" @click="addDiscussReply()">发表</div>
                </div>
            </div>
            <div class="pagination-box" v-if="total > 0">
                <el-pagination class="ou-pagination" background @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="queryParams.pageNum" :page-sizes="[5, 10]"
                    :page-size="queryParams.pageSize" layout="total, prev, pager, next, sizes, jumper, slot"
                    :total="total">
                    <el-button class="ou-page-go">GO</el-button>
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import ClassActivities from './components/ClassActivities'
import ClassMembers from './components/ClassMembers.vue'
import LearnSituation from './components/LearnSituation.vue'
import ReadStatistics from './components/ReadStatistics.vue';
import { getDiscussInfoApi, addDiscussReplyApi, getDiscussDiscussReplyListApi } from '@/api/user/course';
import { goodsInfoDetail, checkIsBuy } from '@/api/bookstore/bookstore'
export default {
    components: {
        ClassActivities,
        ClassMembers,
        LearnSituation,
        ReadStatistics,
    },
    data() {
        return {
            courseDetail: '',
            discussList: [],
            value: '',
            total: 0,
            Info: '',
            content: '',
            goodsId: '',
            bookCover: '',
            bookTitle: '',
            fileInfo: '',
            queryParams: {
                pageNum: 1,
                pageSize: 5,
                discussId: ''
            },
            ReplyList: [],
            Infostatus: '',
            isBuy: false,//是否购买商品
        }
    },
    watch: {
        $route() {
            this.content = ''
            if (this.$route.path == '/course/discussion') {
                this.discussId = this.$route.query.activityId
                this.goodsId = this.$route.query.goodsId
                this.courseDetail = JSON.parse(this.$route.query.courseDetail)
                this.getDiscussInfo()
                this.getGoodInfo()
                this.getDiscussDiscussReplyList()
            }
        }
    },
    created() {
        this.discussId = this.$route.query.activityId
        this.goodsId = this.$route.query.goodsId
        this.courseDetail = JSON.parse(this.$route.query.courseDetail)
        this.getDiscussInfo()
        this.getGoodInfo()
        this.getDiscussDiscussReplyList()

    },
    mounted() {

    },
    methods: {

        getGoodInfo() {
            goodsInfoDetail(this.goodsId).then(res => {
                this.bookCover = res.data.coverFiles[0].fullUrl
                this.bookTitle = res.data.goods.goodsTitle
                this.fileInfo = res.data.sourceList[0]
            })
        },
        getDiscussDiscussReplyList() {
            this.queryParams.discussId = this.discussId
            getDiscussDiscussReplyListApi(this.queryParams).then(res => {
                this.total = res.total
                this.ReplyList = res.rows
            })
        },

        getDiscussInfo() {
            getDiscussInfoApi({
                discussId: this.discussId,
            }).then((res) => {
                this.Info = res.data
                this.checkUserBuy()
            })
        },
        addDiscussReply() {
            if (!this.content) {
                this.$message.error(`回复内容不能为空`);
                return
            }
            getDiscussInfoApi({
                discussId: this.discussId,
            }).then((res) => {
                if (res.data.status == 1) {
                    addDiscussReplyApi({
                        discussId: this.discussId,
                        content: this.content
                    }).then((res) => {
                        if (res.code == 200) {
                            this.content = ''
                            this.queryParams.pageNum = 1
                            this.queryParams.pageSize = 5
                            this.getDiscussDiscussReplyList()

                        }
                    })
                } else {
                    this.$message.error(`活动已结束`);
                }
            })
        },


        checkUserBuy() {
            checkIsBuy({
                relevanceId: this.goodsId,
                type: 'goods',
            }).then(res => {
                if (res.data == '0') {
                    //有权限
                    this.isBuy = true
                } else {
                    //无权限
                    this.isBuy = false
                }
            })
        },

        ToRead() {
            if (this.isBuy) {
                const hrefs = this.$router.resolve({
                    path: "/textBookReader_v2",
                    query: {
                        pageType: 'pc',
                        businessType: 'textBook',
                        goodsId: this.fileInfo.goodsId,
                        textBookId: this.fileInfo.filesId,
                        bookName: this.fileInfo.sourceName,
                    },
                });
                window.open(hrefs.href, '_blank')
            } else {
                this.$message.warning("暂无权限，请联系管理员");
            }
        },
        arrowLeft() {
            this.$router.go(-1);
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getDiscussDiscussReplyList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getDiscussDiscussReplyList();
        },
    }
}
</script>
<style scoped lang='scss'>
.detail-box {
    margin: 0 auto;
    width: 1400px;
    display: flex;
    padding-bottom: 40px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .course-info-box {
        width: 304px;
        height: 704px;
        background: #FFFFFF;
        padding: 20px;
        box-sizing: border-box;

        .course-cover {
            width: 264px;
            height: 264px;
            border-radius: 5px;
        }

        .course-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            margin-top: 18px;
        }

        .text {
            display: flex;
            align-items: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            margin-top: 13px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            img {
                width: 18px;
                height: 18px;
                margin-right: 5px;
            }

            span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .btn {
            width: 263px;
            height: 40px;
            background: #F2F2F2;
            border-radius: 10px 10px 10px 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 19px;
            padding: 0 10px;

            .name {
                width: 70%;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #333333;
                display: flex;
                align-items: center;


                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 8px;
                }

                >div {
                    width: 70%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            .read {
                cursor: pointer;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 13px;
                color: #2E9ADB;
            }
        }
    }

    .resources-box {
        width: calc(100% - 320px);
        min-height: 704px;
        background: #FFFFFF;


    }
}

.discussion_x {
    width: 100%;
    height: 2px;
    background: #F2F2F2;
    margin-top: 2px;
    border-radius: 0px 0px 0px 0px;
}

.discussion_box {
    padding: 11px 16px;

    .discussion_title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        line-height: 21px;

    }

    .discussion_name {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 21px;
        margin-top: 18px;
    }

}

.discussion_row {
    display: flex;
    flex-direction: row;
    align-items: center;

}

.discussion_num {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #2E9ADB;
    line-height: 16px;
    margin-top: 14px;
}

.discussion_time {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    margin-top: 14px;
    margin-left: 40px;

}

.reply_box {
    padding: 10px 0;
    border-top: 2px #F2F2F2 solid;
    margin-top: 10px;

    .name {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
        line-height: 33px;
    }

    .time {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        margin-top: 7px;
        line-height: 14px;
    }

    .reply_title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 16px;
        margin-top: 15px;
    }

    .teaching_reply {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 14px;
        margin-top: 6px;
    }

}

.reply_img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.bottom_box {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 11px 16px;
    // position: fixed;
    width: 100%;
    // bottom: 50px;
}

.bottom_but {
    background-color: #2E9ADB;
    padding: 8px 10px;
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
    width: 80px;
    text-align: center;
    float: right;
    margin-right: 20px;
    // margin-top: 20px;
}

.Details_title {
    padding: 11px 16px;
    font-size: 16px;
    color: #333;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.pagination-box {
    text-align: center;
    margin: 30px 0;
}

::v-deep img {
    max-width: 100%;
}
</style>